import React from "react";
import { Button, Modal } from "react-bootstrap";
import { DepartmentReportStatusSummary } from "@features/report/tag/types/departmentReportStatusSummary";
import DepartmentReportStatusCountBreakdown from "@features/report/tag/components/DepartmentReportStatusCountBreakdown";
import { buildHardBlockMessages } from "@features/report/tag/utils/departmentReportStatusCounts";

const CloseTagBlockedModal: React.FC<{
    show: boolean;
    onHide: () => void;
    summary: DepartmentReportStatusSummary | null;
}> = ({ show, onHide, summary }) => {
    const messages = summary ? buildHardBlockMessages(summary) : null;

    return (
        <Modal
            show={show}
            onHide={onHide}
            backdrop="static"
            keyboard={false}
            centered
            size="lg"
        >
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="fw-semibold">Cannot Close Reporting Period</Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-3">
                {messages && summary && (
                    <>
                        <p>{messages.intro}</p>
                        <p>{messages.wait}</p>
                        <DepartmentReportStatusCountBreakdown
                            summary={summary}
                            mode="blocking"
                            combinedLine={messages.progress}
                        />
                    </>
                )}
            </Modal.Body>
            <Modal.Footer className="border-0 pt-0">
                <Button variant="primary" size="lg" className="btn-action" onClick={onHide}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CloseTagBlockedModal;
